
import { Component, Inject, Vue } from 'vue-property-decorator';
import SimpleFormValidationHandler from '@/util/form/SimpleFormValidationHandler';
import GlobalState from '@/util/GlobalState';
import AuthRepository from '@/repositories/AuthRepository';
import { Subscription } from 'rxjs';
import LoginScaffold from '@/components/scaffolds/LoginScaffold.vue';
import { OnBeforeDestroy, OnCreated } from '@/util/vue/vueCallbacks';

@Component({
    components: { LoginScaffold },
})
export default class Login2FaScreen extends Vue implements OnCreated, OnBeforeDestroy {
    public token = '';
    public error = false;
    public loading = false;
    public validationHandler = new SimpleFormValidationHandler(['token']);

    @Inject() private readonly globalState!: GlobalState;
    @Inject() private readonly authRepository!: AuthRepository;
    private authSubscription = new Subscription();

    public get basicRules(): ((input: any) => boolean | string)[] {
        return [(input) => !!input || this.$t('validation.NotBlank').toString()];
    }

    public created(): void {
        this.validationHandler.translator = this.$i18n;
        this.onGenerateToken();
    }

    public beforeDestroy(): void {
        this.authSubscription.unsubscribe();
    }

    public onRetry() {
        this.$router.push({ name: 'login' });
    }

    public onGenerateToken() {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.authSubscription.unsubscribe();
        this.validationHandler.clearValidation();
        this.authSubscription = this.authRepository.generateOtt().subscribe((response) => {
            if (response.isSuccess) {
                this.globalState.toast(this.$t('login.tokenGenerated').toString());
            } else if (response.isError) {
                this.globalState.toast(this.$t('general.communicationError').toString());
            }
            this.loading = false;
        });
    }

    public onSubmit(): void {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.authSubscription.unsubscribe();
        this.validationHandler.clearValidation();
        this.authSubscription = this.authRepository.loginOtt(this.token).subscribe((loginResponseResource) => {
            if (loginResponseResource.isSuccess && loginResponseResource.data) {
                if (loginResponseResource.data.redirectUri) {
                    window.location.href = loginResponseResource.data.redirectUri;
                } else {
                    this.globalState.toast(this.$t('general.communicationError').toString());
                    this.loading = false;
                }
            } else if (loginResponseResource.isError) {
                const validationError = this.validationHandler.handleErrorResponse(loginResponseResource.error);
                if (validationError) {
                    this.globalState.toast(this.$t('login.validationError').toString());
                } else {
                    this.globalState.toast(this.$t('general.communicationError').toString());
                }
                this.loading = false;
            }
        });
    }
}
